// @flow
import React from 'react';
import { connect, dispatch } from 'react-redux';
import { parse } from 'query-string';
import { fieldChange, saveDetailsAndContinue } from 'redux/ducks/CreateEvent/Details';
import type { EventDetailsFormType } from 'redux/ducks/CreateEvent/Details';
import type { Enums } from 'redux/ducks/helpers';
import ButtonRow from '../ButtonRow';
import CreateEventStepBase from '../CreateEventStepBase';
import EventDetailsForm from './EventDetailsForm';
import ConfirmationRateModal from './ConfirmationRateModal';

export const ONE_TIME_SHOW_CONFIRMATION_RATE_MODAL = "oneTimeShowConfirmationRateModal";

type CreateEventStep1Props = {
  dispatch: typeof dispatch;
  details: EventDetailsFormType;
  enums: Enums;
  canContinue: boolean;
}
class CreateEventStep1 extends CreateEventStepBase<CreateEventStep1Props> {
  PAGE_NUM = 1;
  successAction = saveDetailsAndContinue(this.props.history);

  state = {
    showConfirmationRateModal: false,
    initialPayRate: 0,
  }

  toggleConfirmationRateModal = () => {
    localStorage.setItem(ONE_TIME_SHOW_CONFIRMATION_RATE_MODAL, false);
    this.setState({ showConfirmationRateModal: !this.state.showConfirmationRateModal });
  }

  componentDidMount() {
    this.setState({ canContinue: this.pageIsValid() })
    this.setState({ initialPayRate: this.props.details.payRate });
  }

  onFieldChange = (name: string, newValue: any) => {
    this.props.dispatch(fieldChange(name, newValue));
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.details !== this.props.details) {
      this.setState({ canContinue: this.pageIsValid() })
    }
  }

  onSave = () => {
    let showModal = false;
    if (!this.props.details.id) {
      showModal = this.props.details.payRate >= 150 && this.props.details.rateTypeId == "0" && !localStorage.getItem(ONE_TIME_SHOW_CONFIRMATION_RATE_MODAL);
    }
    else {
      showModal = this.state.initialPayRate != this.props.details.payRate && this.props.details.payRate >= 150 && this.props.details.rateTypeId == "0" && !localStorage.getItem(ONE_TIME_SHOW_CONFIRMATION_RATE_MODAL);
    }
    return showModal ? this.toggleConfirmationRateModal() : this.onSaveAndContinue();
  }

  pageIsValid() {
    const form = document.querySelector('#detailsForm');
    return form instanceof HTMLFormElement && form.checkValidity();
  }

  render() {
    const { details, enums } = this.props;
    return (
      <div className="createEventStep1">
        <EventDetailsForm
          details={details}
          enums={enums}
          onFieldChange={this.onFieldChange}
        />
        <ButtonRow
          saveAsDraft={this.onSaveAsDraft}
          saveAndContinue={this.onSave}
          continueDisabled={!this.state.canContinue}
        />
        <ConfirmationRateModal
          isOpen={this.state.showConfirmationRateModal}
          toggle={this.toggleConfirmationRateModal}
          onConfirm={this.onSaveAndContinue}
          payRate={details.payRate}
        />
      </div>
    );
  }
}

export const formIsValid = () => {
  const form = document.querySelector('#detailsForm');
  return form instanceof HTMLFormElement && form.checkValidity();
}

const mapStateToProps = (state) => {
  return {
    details: state.createEvent.details,
    enums: state.enums,
    canContinue: formIsValid()
  }
}

export { CreateEventStep1 };
export default connect(mapStateToProps)(CreateEventStep1);
